/**
 * DayHeader — barre de contexte compacte de la vue jour
 */
import React, { memo } from 'react';
import { Flame } from 'lucide-react';
import { MoodIndicator } from '../../features/mood';

const DayHeader = memo(function DayHeader({
  dayName, dayNumber, holiday, isWeekend, isNonWorkable,
  mood, onMoodClick, weather, streak = 0, dailyProgress = 0,
}) {
  const hasWeather = weather?.current?.temperature != null;
  const label = holiday ? holiday.name : isWeekend ? 'Week-end' : null;

  return (
    <div
      className="flex items-center justify-between rounded-xl px-3 py-2.5"
      style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}
    >
      {/* Gauche: humeur + date */}
      <div className="flex items-center gap-2.5 min-w-0">
        <div onClick={(e) => { e.stopPropagation(); onMoodClick?.(); }} className="flex-shrink-0">
          {mood?.todayMood ? (
            <MoodIndicator mood={mood.todayMood} energy={mood.todayEnergy} onClick={onMoodClick} />
          ) : (
            <button onClick={onMoodClick}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-lg"
              style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)' }}>
              😶
            </button>
          )}
        </div>
        <div className="min-w-0">
          <h2 className="text-sm font-semibold leading-none" style={{ color: 'rgba(240,240,252,0.88)' }}>
            {dayName} {dayNumber}
          </h2>
          {label && (
            <span className="text-[10px] mt-0.5 block" style={{ color: 'rgba(255,255,255,0.32)' }}>
              {label}
            </span>
          )}
        </div>
      </div>

      {/* Droite: météo + progression + streak */}
      <div className="flex items-center gap-2 flex-shrink-0">
        {dailyProgress > 0 && (
          <div className="flex items-center gap-1.5">
            <div className="w-16 h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.06)' }}>
              <div className="h-full rounded-full" style={{ width: `${dailyProgress}%`, background: 'linear-gradient(90deg, #6366f1, #8b5cf6)' }} />
            </div>
            <span className="text-[10px] font-mono tabular-nums" style={{ color: 'rgba(255,255,255,0.30)' }}>
              {dailyProgress}%
            </span>
          </div>
        )}
        {hasWeather && (
          <div className="flex items-center gap-1 px-2 py-1 rounded-lg"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}>
            <span className="text-sm leading-none">{weather.current.icon}</span>
            <span className="text-xs font-medium tabular-nums" style={{ color: 'rgba(255,255,255,0.55)' }}>
              {weather.current.temperature}°
            </span>
          </div>
        )}
        {streak > 0 && (
          <div className="flex items-center gap-1">
            <Flame className="w-3.5 h-3.5" style={{ color: '#fb923c' }} />
            <span className="text-xs font-bold" style={{ color: '#fb923c' }}>{streak}</span>
          </div>
        )}
      </div>
    </div>
  );
});

export { DayHeader };
export default DayHeader;
